<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10 mx-3"
        v-on="on"
      >
        Create Duty Rosters
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Duty Rosters"
      text="Create Duty Rosters"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col
            cols="5"
            class="form-overflow pr-8 pt-2"
            data-simplebar
          >
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  v-model="dates"
                  v-validate="'required'"
                  :error-messages="errors.collect('dates')"    
                  data-vv-name="dates"
                  data-vv-as="dates"
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  outlined
                  label="Date"
                  prepend-inner-icon="mdi-calendar"
                  class="label-position"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dates"
                :min="today"
                multiple
                no-title
                scrollable
              />
            </v-menu>
            <v-text-field
              v-model="startTime"
              v-validate="'required|time_before_or_equal:' + endTime"
              :error-messages="errors.collect('startTime')"    
              data-vv-name="startTime"
              data-vv-as="start time"
              outlined
              label="Start Time"
              type="time"
            />
            <v-text-field
              v-model="endTime"
              v-validate="'required|time_after_or_equal:' + startTime"
              :error-messages="errors.collect('endTime')"    
              data-vv-name="endTime"
              data-vv-as="end time"
              outlined
              label="End Time"
              type="time"
            />
            <v-textarea
              v-model="remark"
              :rows="2"
              outlined
              label="Remark"
            />
          </v-col>
          <v-col cols="7">
            <v-card class="pa-4 elevation-5">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee"
                hide-no-data
                hide-selected
              />
              <v-autocomplete
                v-model="filters.positions"
                :items="positions"
                item-text="label"
                item-value="id"
                value="id"
                label="Position"
                placeholder="Filter employee by position"
                clearable
                hide-selected
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove('positions', data.item)"
                  >
                    {{ data.item.label }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="filters.departments"
                :items="departments"
                item-text="name"
                item-value="id"
                value="id"
                label="Department"
                placeholder="Filter employee by department"
                clearable
                hide-selected
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove('departments', data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-data-table
                v-model="selectedEmployees"
                v-validate="'required'"
                :error-messages="errors.collect('selectedEmployees')"
                data-vv-name="selectedEmployees"
                data-vv-as="employees"
                dense
                :loading="tableLoading"
                :headers="headers"
                :items="filteredEmployees"
                item-key="employee_uid"
                hide-default-footer
                fixed-header
                disable-pagination
                item-value="employee_uid"
                show-select
                class="elevation-1 mb-3"
                height="300px"
              >
                <template v-slot:top>
                  <h5 class="font-weight-bold py-2 mb-0 pl-2">
                    Employee Selection:
                  </h5>
                </template>
              </v-data-table>
              <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions class="mt-n5">  
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"  
          class="px-10 white--text"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        componentKey: 0,
        dateMenu: false,
        dialog: false,
        employees: [],
        filters: {
          positions: '',
          departments: '',
        },
        form: [
        ],
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'person.name',
          },      
        ],
        monthMenu: false,
        positions: [],
        progressing: false,
        searchInput: '',
        selectedEmployees: [],
        tableLoading: false,
        departments: [],
        dates: [],
        today: new Date().toISOString().slice(0, 10),
        startTime: '00:00:00',
        endTime: '00:00:00',
        remark: null,
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })
        let filteredPositions = this.customFilterPositions(primaryFilterEmployees)
        let filteredDepartments = this.customFilterDepartments(filteredPositions)

        return filteredDepartments
      },
    },
    watch: {
      dialog (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }

        function toMinutes (time) {
          if (!time) return null
          const [h, m] = time.split(':')
          return (parseInt(h) * 60) + parseInt(m)
        }

        this.$validator.extend('time_before_or_equal', {
          getMessage (field, args) {
            return `The ${field} must be earlier than end time.`
          },
          validate (value, args) {
            const [otherValue] = args
            return toMinutes(value) <= toMinutes(otherValue)
          },
        })

        this.$validator.extend('time_after_or_equal', {
          getMessage (field, args) {
            return `The ${field} must be later than start time.`
          },
          validate (value, args) {
            const [otherValue] = args
            return toMinutes(value) >= toMinutes(otherValue)
          },
        })
      },
    },
    methods: {
      loadData () {
        this.tableLoading = true

        this.$api.employees().list('?with=notResigned')
          .then(response => {
            this.employees = _.orderBy(response.data, ['person.name'], ['asc'])
            this.tableLoading = false
          })
          .catch(() => {})

        this.$api.positions().list()
          .then(response => {
            this.positions = response.data.map(pos => ({
              id: pos.id,
              label: `${pos.name} (${pos.job_grade.job_group.name})`,
            }))
          })
          .catch(() => {})

        this.$api.hrisDepartments().list()
          .then(response => {
            this.departments = _.orderBy(response.data, ['name'], ['asc'])
          })
          .catch(() => {})
      },
      customFilterPositions (employeesList) {
        if (this.filters.positions.length === 0) return employeesList

        return employeesList.filter(employee => {
          let positionId = (employee.current_position || {}).position_id

          return _.intersection([positionId], this.filters.positions).length > 0
        })
      },
      customFilterDepartments (employeesList) {
        if (this.filters.departments.length === 0) return employeesList

        return employeesList.filter(employee => {
          let departmentId = (employee || {}).department_id

          return _.intersection([departmentId], this.filters.departments).length > 0
        })
      },
      rerender () {
        this.componentKey++ // To force the component to re-render due to data-simplebar bug
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.dutyRosters().createMany(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created')             
                  this.$snack({ message: 'Duty rosters created' })

                  this.dialog = false               
                }
              }).catch((e) => {
                if (e.response.status === 409) {
                  const formattedMessage = e.response.data.status.replace(/<br>/gi, '\n')
                
                  this.$dialog({
                    title: 'Error',
                    message: formattedMessage, 
                    color: 'error',
                  })

                  this.$emit('created')
                  this.progressing = false
                  this.dialog = false
                } else {
                  this.$snack({ 
                    color: 'error',
                    message: 'Failed to create duty rosters', 
                  })
                }
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {        
        return {
          employees: this.selectedEmployees.map(emp => emp.employee_uid),
          dates: this.dates,
          start_time: this.startTime,
          end_time: this.endTime,
          remark: this.remark,
        }
      },
      remove (key, item) {
        let index = this.filters[key].findIndex(selectedId => selectedId === item.id)

        if (index >= 0) this.filters[key].splice(index, 1)
      },
    },
  }
</script>

<style lang="css" scoped>
  .form-overflow {
    height: 70vh;
  }
  .label-position >>> .v-label.v-label--active{
    margin-left:-28px;
    background:white;
    padding-right:5px
  }
</style>
